import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { GiftcardsAmountSelectorComponentDef } from '@df/module-giftcards/giftcards-amount-selector.component.def';
import { PriceComponent } from '@df/ui/price/price.component';
import { PricePipe } from '@df/ui/price/price.pipe';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';

@Component({
    selector: 'giftcards-amount-selector',
    templateUrl: './giftcards-amount-selector.html',
    standalone: true,
    imports: [CommonModule, FormsModule, PriceComponent, PricePipe, TranslatePipe],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiftcardsAmountSelectorComponent extends GiftcardsAmountSelectorComponentDef {
    /**
     * Input custom amount element
     * important: you need to put #customAmount on input element in template
     */
    @ViewChild('customAmount', { static: false })
    customAmount!: ElementRef;

    show = false;

    showCustomAmountField() {
        this.show = true;
        setTimeout(() => this.customAmount.nativeElement.focus(), 20);
        this.detectChanges();
    }

    onCustomAmountBlur() {
        this.onCustomAmountChange();
        this.show = false;
        this.detectChanges();
    }

    onKeypress(event: KeyboardEvent) {
        // Allow key codes for special events. Reflect :
        // Backspace, tab, end, home
        const specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

        // Allow decimal numbers and negative values
        const regex = new RegExp('^\\d{1,}[.]?\\d{0,2}$', 'g');

        const el: HTMLInputElement = event.target as HTMLInputElement;

        // Allow Backspace, tab, end, and home keys
        if (specialKeys.indexOf(event.key) !== -1) {
            return;
        }

        const current: string = el.value;
        const startPosition = el.selectionStart || 0;
        const endPosition = el.selectionEnd || 0;
        const next: string = [current.slice(0, startPosition), event.key, current.slice(endPosition)].join('');

        // prevent enter char
        if (next && !String(next).match(regex)) {
            event.preventDefault();
        }
    }
}
